import { Switch, Match } from "solid-js";
import type { MainProps } from "./_model";
import { global } from ":shared/app";

export default function AuthLayout(props: MainProps) {
  const $breakpoint = global.store.hooks.dom.useBreakpoints();
  return (
    // no need for fallback since we're using desktop as default!
    <Switch>
      {/* phones and tablets */}
      <Match when={$breakpoint()?.misc.lg.widthIsLess}>
        <main class="grid grid-rows-[100px_70%] w-full h-full content-center px-2 py-2 gap-2">
          <div class="flex w-full h-100px max-h-100px items-center justify-center overflow-hidden">
            <img class="w-fit h-full" src="/logo-auth.svg" alt="logo-auth" />
          </div>
          <section class="flex flex-col w-full h-full">{props.children}</section>
        </main>
      </Match>
      {/* desktop */}
      <Match when={true}>
        <main class="grid grid-cols-[45%_50%] w-full h-full justify-between gap-2 ">
          <div class="flex flex-col w-full h-full justify-center items-center pl-10 py-2 gap-3 overflow-y-auto overflow-x-hidden">
            <div class="flex w-full h-150px max-h-150px items-start overflow-hidden">
              <img class="w-full h-full" src="/logo-auth.svg" alt="logo-auth" />
            </div>
            <section class="flex flex-col w-full h-fit overflow-hidden ">{props.children}</section>
          </div>
          <div class="flex flex-col w-full h-full overflow-hidden">
            <img class="w-101% h-auto" src="/auth-side-bg.svg" alt="auth-side-bg" />
          </div>
        </main>
      </Match>
    </Switch>
  );
}
